"use client";
import { jsx as u, jsxs as M } from "react/jsx-runtime";
import k from "clsx";
import { memo as w, useState as l } from "react";
import '../../../assets/UndressSettingsBlock.css';const T = "_settings_block_gc32m_1", x = "_active_gc32m_13", Y = "_settings_inner_gc32m_19", b = "_settings_curtain_gc32m_54", a = {
  settings_block: T,
  active: x,
  settings_inner: Y,
  settings_curtain: b
}, D = w(
  ({ active: m, onClose: s, children: p }) => {
    const [g, _] = l(0), [n, e] = l(!1), [r, o] = l(0), h = (t) => {
      _(t.clientY), e(!0);
    }, S = (t) => {
      const c = t.clientY - g;
      o(n && c > 0 ? c : 0), s && n && r > 70 && (s(), o(0), e(!1));
    }, d = (t) => {
      _(t.changedTouches[0].clientY), e(!0);
    }, f = (t) => {
      const c = t.changedTouches[0].clientY - g;
      o(n && c > 0 ? c : 0), s && n && r > 70 && (s(), o(0), e(!1));
    }, i = () => {
      o(0), e(!1);
    }, v = (t) => {
      t.preventDefault(), t.stopPropagation();
    };
    return /* @__PURE__ */ u("div", { className: k(a.settings_block, { [a.active]: m }), children: /* @__PURE__ */ M(
      "div",
      {
        className: a.settings_inner,
        style: n && s ? { transform: `translateY(${r}px)`, transition: "0s" } : {},
        children: [
          /* @__PURE__ */ u(
            "span",
            {
              className: a.settings_curtain,
              onMouseDown: h,
              onMouseMove: S,
              onMouseUp: i,
              onMouseLeave: i,
              onTouchStart: d,
              onTouchMove: f,
              onTouchEnd: i,
              onTouchCancel: i,
              onScroll: v
            }
          ),
          p
        ]
      }
    ) });
  }
);
D.displayName = "UndressSettingsBlock";
export {
  D as UndressSettingsBlock
};
